import React, {useEffect, useState} from 'react';

import StatCard from '../components/dashboard/StatCard';
import SmallStat from '../components/dashboard/SmallStat';
import EnrollmentByTermChart from '../components/dashboard/EnrollmentByTermChart';

import FadeIn from '../components/common/FadeIn';
import Skeleton from '../components/common/Skeleton';

import ApplicationStatusProgress from "../components/dashboard/ApplicationStatusProgress";
import ApplicationTrendChart from "../components/dashboard/ApplicationTrendChart";
import NotificationBox from "../components/dashboard/NotificationBox";

import { dashboardService } from "../../core/services/dashboardService";


const IndexPage = () => {

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);

    // 🔥 BURASI ARTIK DIŞARI ALINDI
    const loadDashboard = async () => {
        try {
            setLoading(true);
            const res = await dashboardService.getDashboard();
            setData(res);
        } catch (e) {
            console.error("Dashboard load failed", e);
        }
        setLoading(false);
    };

    useEffect(() => {
        loadDashboard();
    }, []);

    return (
        <div className="page-container">

            {/* ================= STATS ================= */}
            <div className="grid-4">
                <FadeIn delay={0}>
                    <StatCard
                        loading={loading}
                        title="Toplam Başvuru"
                        value={data?.applications.total || 0}
                        subtitle="Sisteme yapılan toplam başvuru"
                        color="var(--valtekInfo)"
                    />
                </FadeIn>

                <FadeIn delay={0.05}>
                    <StatCard
                        loading={loading}
                        title="Yeni Başvurular"
                        value={data?.applications.NEW || 0}
                        subtitle="Bekleyen başvurular"
                        color="var(--valtekWarning)"
                    />
                </FadeIn>

                <FadeIn delay={0.1}>
                    <StatCard
                        loading={loading}
                        title="İncelemede Olan"
                        value={data?.applications.REVIEWING || 0}
                        subtitle="Şu anda değerlendirilen başvurular"
                        color="var(--valtekWarning)"
                    />
                </FadeIn>

                <FadeIn delay={0.15}>
                    <StatCard
                        loading={loading}
                        title="Onaylanan Başvurular"
                        value={data?.applications.APPROVED || 0}
                        subtitle="Kabul edilen başvurular"
                        color="var(--valtekGreen)"
                    />
                </FadeIn>
            </div>


            {/* ================= SMALL STATS ================= */}
            <div className="grid-3 mt-24">

                <FadeIn delay={0.2}>
                    <SmallStat
                        loading={loading}
                        title="Bugün"
                        value={`${data?.today.applications || 0} başvuru`}
                        subtitle={`${data?.today.approved} onaylandı`}
                    />
                </FadeIn>

                <FadeIn delay={0.25}>
                    <SmallStat
                        loading={loading}
                        title="Bu Hafta"
                        value={`${data?.thisWeek.applications || 0} başvuru`}
                        subtitle={`${data?.thisWeek.approved} onaylandı`}
                    />
                </FadeIn>

                <FadeIn delay={0.3}>
                    <SmallStat
                        loading={loading}
                        title="Aktif Dönem"
                        value={data?.activeTerm?.name || "-"}
                        subtitle={`${data?.activeTerm?.enrollmentCount ?? 0} öğrenci`}
                    />
                </FadeIn>

            </div>


            {/* ================= NOTIFICATIONS ================= */}
            <div className="grid-2 mt-24">

                <FadeIn delay={0.1}>
                    <NotificationBox
                        title="Yeni Başvurular"
                        status="NEW"
                        onRefresh={loadDashboard}   // 🔥
                    />
                </FadeIn>

                <FadeIn delay={0.15}>
                    <NotificationBox
                        title="İncelemedeki Başvurular"
                        status="REVIEWING"
                        onRefresh={loadDashboard}   // 🔥
                    />
                </FadeIn>

            </div>


            {/* ================= CHARTS ================= */}
            <div className="grid-3-chart mt-24">

                <FadeIn delay={0.2}>
                    {loading ? (
                        <div className="card">
                            <Skeleton height={18} width="30%"/>
                            <div style={{height: 12}}/>
                            <Skeleton height={260}/>
                        </div>
                    ) : (
                        <EnrollmentByTermChart data={data?.enrollmentsByTerm || []}/>
                    )}
                </FadeIn>

                <FadeIn delay={0.25}>
                    {loading ? (
                        <div className="card">
                            <Skeleton height={18} width="30%"/>
                            <div style={{height: 12}}/>
                            <Skeleton height={260}/>
                        </div>
                    ) : (
                        <ApplicationStatusProgress
                            data={[
                                {name: 'Approved', value: data.applications.APPROVED},
                                {name: 'Reviewing', value: data.applications.REVIEWING},
                                {name: 'New', value: data.applications.NEW},
                                {name: 'Rejected', value: data.applications.REJECTED},
                                {name: 'Withdrawn', value: data.applications.WITHDRAWN},
                            ]}
                        />
                    )}
                </FadeIn>

                <FadeIn delay={0.3}>
                    {loading ? (
                        <div className="card">
                            <Skeleton height={18} width="30%"/>
                            <div style={{height: 12}}/>
                            <Skeleton height={260}/>
                        </div>
                    ) : (
                        <ApplicationTrendChart data={data?.applicationTrend || []}/>
                    )}
                </FadeIn>

            </div>

        </div>
    );
};

export default IndexPage;
